
class PedometerDummy{
    getToday() {
        return new Promise((resolve, reject) => {
            reject;
            resolve({
                data : [{count : 7, date : '20240626', "id" : '1'}]
            })
        })
    }

    getLast(count) {
        return new Promise((resolve, reject) => {
            reject;count;
            resolve({
                data : [
                    {count : 32, date : '20250331', "id" : '1'},
                    {count : 12, date : '20250330', "id" : '1'},
                    {count : 21, date : '20250327', "id" : '1'},
                ]
            })
        })
    }
}
class PedometeriOS {
    getToday() {
        const p  = new Promise((resolve,reject)=>{
            try {
                window.PedometerComplete = function(res){
                    console.log(res);
                    resolve(res);
                };
                window.webkit.messageHandlers.Pedometer.postMessage({"cmd":"getTodayWalkCount"});
        }catch(e) {
            reject(e);
        }

    });
    return p;
    }
    getAll() {
        const p  = new Promise((resolve,reject)=>{ 
            try {
            window.PedometerComplete = function(res){
                console.log(res);
                resolve(res);
            };
            window.webkit.messageHandlers.Pedometer.postMessage({"cmd":"getAllWalkCount"});
        }catch(e) {
            reject(e);
        }
    });

        return p;
    }
    getLast(count) {
        console.log(count);
        const p  = new Promise((resolve,reject)=>{
            try {
            window.PedometerComplete = function(res){
                console.log(res);
                resolve(res);
            };
        window.webkit.messageHandlers.Pedometer.postMessage({"cmd":"getAllWalkCount"});
        }catch(e) {
            reject(e);
        }
    });

        return p;
    }
}

class PedometerAndroid {
    constructor() {
        this.nativeObj = window.Pedometer;
    }

    getToday() {
        return new Promise((resolve,reject)=> {
            if(this.nativeObj == null) {
                reject("not support platform");
                return;
            }
            let res = this.nativeObj.getTodayWalkCount();
            console.log(res);
            resolve(JSON.parse(res));
        });
    }
    getAll() {
        return new Promise((resolve,reject)=> {
            if(this.nativeObj == null) {
                reject("not support platform");
                return;
            }
            let res = this.nativeObj.getAllWalkCount();
            console.log(res);
            resolve(JSON.parse(res));
        });
    }
    getLast(count) {
        return new Promise((resolve,reject)=> {
            if(this.nativeObj == null) {
                reject("not support platform");
                return;
            }
            let res = this.nativeObj.getLastWalkCount(count);
            console.log(res);
            resolve(JSON.parse(res));
        });
    }
}

let Pedometer = null;
if(window.Pedometer) {
    Pedometer = new PedometerAndroid();
}else if(window.webkit && window.webkit.messageHandlers.Pedometer) {
    Pedometer = new PedometeriOS();
}else {
    Pedometer = new PedometerDummy();
}

export default Pedometer;
